module.exports = __webpack_public_path__ + "static/media/rightarrow.536f5269.svg";